import React from "react"
import { Card, CardContent, CardFooter, CardHeader } from "../../../components/ui/card"
import { Button } from "../../../components/ui/button"
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "../../../components/ui/dropdown-menu"
import { MoreVertical, Eye, ViewIcon, RefreshCwIcon, Mail, Building, Calendar } from "lucide-react"

export const PartnerGridList = ({
    partnerships,
    tenant,
    getCompanyLogo,
    handleDetailsView,
    handleNavigateToCatalogue,
    handleConfirmationModal,
    handleResendInvitation,
    getStatusBadge,
    formatDate,
    isDropdownOpen,
    setIsDropdownOpen,
}) => {
    return (
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {partnerships.map((partnership, index) => (
                <Card key={partnership.id} className="overflow-hidden hover:shadow-md transition-shadow">
                    <CardHeader className="p-4 pb-2 flex flex-row items-start justify-between space-y-0">
                        <div className="flex items-center space-x-3">
                            {getCompanyLogo(partnership.invitedTo, partnership.logo)}
                            <div>
                                <h3 className="font-semibold">{partnership.invitedTo}</h3>
                                <p className="text-sm text-gray-500">{partnership.userType}</p>
                            </div>
                        </div>
                        <DropdownMenu onOpenChange={(isOpen) => setIsDropdownOpen(isOpen ? index : null)} open={isDropdownOpen === index}>
                            <DropdownMenuTrigger asChild>
                                <Button variant="ghost" size="icon" className="h-8 w-8">
                                    <MoreVertical className="h-4 w-4" />
                                </Button>
                            </DropdownMenuTrigger>
                            <DropdownMenuContent align="end">
                                <DropdownMenuItem disabled={partnership.invitedToTenantId === tenant?.id || partnership.notificationStatus !== "Accept"} onClick={() => handleNavigateToCatalogue(partnership)}>
                                    <ViewIcon className="h-4 w-4 mr-2" /> View Catalogue
                                </DropdownMenuItem>
                                {partnership.invitedToTenantId !== tenant?.id && (partnership.notificationStatus !== "Accept") && (
                                    <DropdownMenuItem
                                        onClick={() => {
                                            setIsDropdownOpen(false);
                                            handleConfirmationModal(true, () => handleResendInvitation(partnership.id));
                                        }}>
                                        <RefreshCwIcon className="h-4 w-4 mr-2" />
                                        Resend
                                    </DropdownMenuItem>
                                )}
                            </DropdownMenuContent>
                        </DropdownMenu>
                    </CardHeader>
                    <CardContent className="p-4 pt-0">
                        <div className="space-y-3">
                            <div className="flex items-center text-sm">
                                <Mail className="h-4 w-4 mr-2 text-gray-500" />
                                <span className="text-gray-600 truncate">{partnership.userEmail}</span>
                            </div>
                            <div className="flex items-center text-sm">
                                <Building className="h-4 w-4 mr-2 text-gray-500" />
                                <span className="text-gray-600">From: {partnership.invitedFromTenantName}</span>
                            </div>
                            <div className="flex items-center text-sm">
                                <Calendar className="h-4 w-4 mr-2 text-gray-500" />
                                <span className="text-gray-600">{formatDate(partnership.createdDate)}</span>
                            </div>
                        </div>
                    </CardContent>
                    <CardFooter className="p-4 pt-0 flex justify-between items-center">
                        {getStatusBadge(partnership.notificationStatus)}
                        <Button
                            variant="outline"
                            size="sm"
                            className="text-purple-700 hover:text-purple-900"
                            onClick={() => handleDetailsView(partnership, true)}
                        >
                            View Company
                        </Button>
                    </CardFooter>
                </Card>
            ))}
        </div>
    )
}
